import { CLASS_INSTANCE_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  calendars: [],
  classInstances: [],
  classInstance: null,
  classInstanceId: null,
  newClass: false,
  classList: [],
  studios: [],
  rooms: [],
  instructors: [],
  classInstancePopup: null,
  invalidPackModal: null,
  invalidPackMessageModal: '',
  studioModal: false,
  roomModal: false,
  clientProfileModal: false,
  addNotesModal: null,
  clientProfileData: {
    emailId: '',
    phone: '',
  },
  error: null,
  instructorFilter: {
    search: '',
    checked: [],
  },
  classesFilter: {
    search: '',
    checked: [],
  },
  studioFilter: {
    search: '',
    checked: [],
  },
  timePeriodFilter: {
    startDate: '',
    endDate: '',
  },
  isABP: false,
  requestedClassInstanceId: null,
  bookedClassList: [],
  processingSignUpReq: false,
  classInstanceSignedUpCount: {},
  backButtonEnabled: false,
  clientReport: [],
  clientData: [],
  roomEditModal: false,
  roomEditModalValues: {},
};

const classInstanceReducer = (state, { type, payload }) => {
  switch (type) {
    case CLASS_INSTANCE_EVENTS.REQUEST:
      return { ...state, loading: true };

    case CLASS_INSTANCE_EVENTS.SUCCESS: {
      return { ...state, loading: false };
    }

    case CLASS_INSTANCE_EVENTS.FAIL:
      return { ...state, loading: false, error: payload };

    case CLASS_INSTANCE_EVENTS.SET: {
      return { ...state, loading: false, ...payload };
    }

    case CLASS_INSTANCE_EVENTS.SET_CLASSES_FILTER: {
      return { ...state, loading: false, classesFilter: { ...state.classesFilter, ...payload } };
    }

    case CLASS_INSTANCE_EVENTS.SET_STUDIO_FILTER: {
      return { ...state, loading: false, studioFilter: { ...state.studioFilter, ...payload } };
    }

    case CLASS_INSTANCE_EVENTS.SET_TIMEPERIOD_FILTER: {
      return {
        ...state,
        loading: false,
        timePeriodFilter: { ...state.timePeriodFilter, ...payload },
      };
    }

    case CLASS_INSTANCE_EVENTS.SET_INSTRUCTOR_FILTER: {
      return {
        ...state,
        loading: false,
        instructorFilter: { ...state.instructorFilter, ...payload },
      };
    }

    case CLASS_INSTANCE_EVENTS.RESET_FILTER: {
      return {
        ...state,
        loading: false,
        classesFilter: initialState.classesFilter,
        instructorFilter: initialState.instructorFilter,
      };
    }

    case CLASS_INSTANCE_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default classInstanceReducer;
